import { render, staticRenderFns } from "./IconScheme.vue?vue&type=template&id=e4ecfec6&"
import script from "./IconScheme.vue?vue&type=script&lang=js&"
export * from "./IconScheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports